import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import dayjs from "dayjs";
import TextFieldDateTime from "../UI/TextFieldDateTime";
import UsuarioFindDialog from "../Usuario/UsuarioFindDialog";

const TarefaForm = ({ tarefa, setTarefa, clickSubmit, handleRemove, isLoadingAction }) => {
  const [openSearchUsuario, setOpenSearchUsuario] = useState(false);

  const updateField = (name, value) => {
    setTarefa((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSelectedUsuario = (usuarioAdd) => {
    updateField("usuarioPara", usuarioAdd);
    setOpenSearchUsuario(false);
  };

  return (
    <>
      <UsuarioFindDialog
        openSearchUsuario={openSearchUsuario}
        handleSelectedUsuario={handleSelectedUsuario}
        closeUsuarioSearch={() => setOpenSearchUsuario(false)}
      />
      <Stack component="form" onSubmit={clickSubmit} spacing={2.5}>
        <TextField
          size="small"
          fullWidth
          multiline
          minRows={2}
          required
          label="Descrição"
          value={tarefa.descricao || ""}
          onChange={(event) => updateField("descricao", event.target.value)}
        />

        <Stack direction="row" spacing={1} alignItems="center">
          <TextField
            size="small"
            fullWidth
            required
            label="Atribuir para"
            placeholder="Selecione um usuário"
            value={tarefa.usuarioPara ? `${tarefa.usuarioPara.nome ?? ""} (${tarefa.usuarioPara.email})` : ""}
            onClick={() => setOpenSearchUsuario(true)}
            slotProps={{ input: { readOnly: true } }}
          />
          {tarefa.usuarioPara && (
            <Tooltip title="Remover usuário">
              <IconButton onClick={() => updateField("usuarioPara", null)}>
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}
          <Button
            variant="outlined"
            startIcon={<PersonSearchOutlinedIcon />}
            onClick={() => setOpenSearchUsuario(true)}
            sx={{ flexShrink: 0 }}
          >
            Buscar
          </Button>
        </Stack>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(tarefa.possuiPrazo)}
                onChange={(event) => updateField("possuiPrazo", event.target.checked)}
              />
            }
            label="Possui prazo"
          />
          {tarefa.possuiPrazo && (
            <TextFieldDateTime
              label="Data Hora Prazo"
              value={tarefa.dataHoraPrazo || null}
              onChange={(value) => updateField("dataHoraPrazo", dayjs(value))}
              slotProps={{ textField: { size: "small", required: true } }}
            />
          )}
        </Stack>

        <Stack direction="row" justifyContent="space-between">
          <Box>
            {!tarefa.eNovo && (
              <Button
                color="error"
                startIcon={<DeleteOutlineIcon />}
                disabled={isLoadingAction}
                onClick={() => handleRemove(tarefa)}
              >
                Remover
              </Button>
            )}
          </Box>
          <Button type="submit" variant="contained" disabled={isLoadingAction}>
            Salvar
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default TarefaForm;
